<ng-container *transloco="let t">
  <mc-table
    fit="small"
    [data]="tableData"
    [columns]="tableColumns"
    [disablerowhighlightonhover]="isLoading || tableData.length === 0"
    (rowclick)="onRowClicked($event)"
  >
    @if (isLoading) {
      <mc-loading-indicator slot="state"></mc-loading-indicator>
    } @else {
      @if (tableData.length === 0) {
        <ng-content></ng-content>
      } @else {
        @for (item of tableData; track item.id) {
          <span slot="{{ item.id }}_activeVersion">
            @if (
              item.activeVersion != null &&
              item.activeVersion !== item.latestVersion
            ) {
              <span
                >v{{ item.activeVersion
                }}{{ t("carrier_integrations_latest_v_prefix")
                }}{{ item.latestVersion }}</span
              >
            } @else if (item.activeVersion != null) {
              <span>v{{ item.latestVersion }}</span>
            } @else {
              <span class="carrier-config-version-cell"
                >v{{ item.latestVersion }}
                <mc-tag
                  class="carrier-config-version-tag"
                  appearance="neutral-weak"
                  [label]="t('inactive')"
                ></mc-tag
              ></span>
            }
          </span>

          <span slot="{{ item.id }}_updatedAtUtc">{{ item.updatedAtUtc }}</span>

          <span slot="{{ item.id }}_id">
            <mc-menu trigger="click" position="bottom-right">
              <mc-button
                slot="trigger"
                icon="ellipsis-vertical"
                variant="plain"
                appearance="neutral"
                hiddenlabel
              ></mc-button>
              <mc-list (listchange)="onMenuSelected($event, item)">
                <mc-list-item
                  [label]="t('edit')"
                  value="edit"
                  icon="pencil"
                ></mc-list-item>
                <mc-list-item
                  [label]="t('carrier_integrations_test')"
                  value="test"
                  icon="play-circle"
                ></mc-list-item>
                <mc-list-item
                  [label]="t('carrier_integrations_tracking')"
                  value="tracking"
                  icon="pin"
                ></mc-list-item>
                @if (showActivate(item)) {
                  <mc-list-item
                    [label]="t('activate')"
                    value="activate"
                    icon="check-circle"
                  ></mc-list-item>
                }
                @if (showSwitchActiveVersion(item)) {
                  <mc-list-item
                    [label]="t('carrier_integrations_switch_active_version')"
                    value="switch_active_version"
                    icon="arrow-left"
                  ></mc-list-item>
                }
                <mc-list-item
                  [label]="t('delete')"
                  value="delete"
                  icon="trash"
                ></mc-list-item>
              </mc-list>
            </mc-menu>
          </span>
        }
      }
    }
  </mc-table>
</ng-container>
